import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import useFooter from '../hooks/use-footer';

export default () => {
  const data = useFooter();
  return (
    <div className="footer-strip">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-6 footer footer-left">
            <ul>
              {data.allBadgesJson.nodes.map((badge) => (
                <li key={`footer-badge-${badge.name}`}>
                  <GatsbyImage
                    image={badge.src.childImageSharp.gatsbyImageData}
                    alt={badge.name}
                  />
                </li>
              ))}
            </ul>
          </div>
          <div className="col-6">
            <div className="footer footer-right float-right">
              <ul className="text-nowrap">
                {data.siteJson.footerLinks.map((footerLink) => (
                  <li key={`'footer-link-${footerLink.name}`}>
                    <Link to={footerLink.link}>{footerLink.name}</Link>
                  </li>
                ))}
                <li key="footer-link-copyright" className="copyright">
                  {`© ${new Date().getFullYear()} ${data.siteJson.title}`}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
